import { render, staticRenderFns } from "./profiles-card.vue?vue&type=template&id=2bc860a6&scoped=true&"
import script from "./profiles-card.vue?vue&type=script&lang=js&"
export * from "./profiles-card.vue?vue&type=script&lang=js&"
import style0 from "./profiles-card.vue?vue&type=style&index=0&id=2bc860a6&prod&lang=scss&"
import style1 from "./profiles-card.vue?vue&type=style&index=1&id=2bc860a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc860a6",
  null
  
)

export default component.exports